export const environment = {
  production: true,
  shopifyApiKey: 'fe034f5af2a946a07341eec6837ccc61',
  baseURL: 'a-review.co',
  environment: 'production',
};
